"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var lodash_1 = require("lodash");
var utils_1 = require("../../../../utils");
var ConditionType;
(function (ConditionType) {
    ConditionType["EQUAL"] = "Equal to";
    ConditionType["NOT_EQUAL"] = "Not Equal to";
    ConditionType["BETWEEN"] = "Between";
    ConditionType["NOT_BETWEEN"] = "Not Between";
    ConditionType["GREATER_THAN"] = "Great Than";
    ConditionType["GREATER_THAN_OR_EQUAL"] = "Great Than or Equal To";
    ConditionType["LESS_THAN"] = "Less Than";
    ConditionType["LESS_THAN_OR_EQUAL"] = "Less Than or Equal To";
    ConditionType["CONTAINS"] = "Contains";
    ConditionType["NOT_CONTAINS"] = "Does Not Contains";
    ConditionType["IS_SPECIFIED"] = "Is Specified";
    ConditionType["IS_NOT_SPECIFIED"] = "Is Not Specified";
    ConditionType["IN"] = "In";
    ConditionType["NOT_IN"] = "Not in";
    ConditionType["IS"] = "Is";
    ConditionType["NOT_IS"] = "Is Not";
})(ConditionType = exports.ConditionType || (exports.ConditionType = {}));
function fieldTypesByCondition(conditionType) {
    var result = [];
    switch (conditionType) {
        case ConditionType.EQUAL:
        case ConditionType.NOT_EQUAL:
        case ConditionType.GREATER_THAN:
        case ConditionType.GREATER_THAN_OR_EQUAL:
        case ConditionType.LESS_THAN:
        case ConditionType.LESS_THAN_OR_EQUAL:
        case ConditionType.BETWEEN:
        case ConditionType.NOT_BETWEEN:
            result.push(idm_kb_service_client_js_1.MetaFieldType.INTEGER);
            result.push(idm_kb_service_client_js_1.MetaFieldType.DECIMAL);
            result.push(idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL);
            break;
        case ConditionType.CONTAINS:
        case ConditionType.NOT_CONTAINS:
            result.push(idm_kb_service_client_js_1.MetaFieldType.STRING);
            // result.push(MetaFieldType.MULTILINGUAL_STRING);
            break;
        case ConditionType.IN:
        case ConditionType.NOT_IN:
            result.push(idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER);
            result.push(idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT);
            break;
        case ConditionType.IS:
        case ConditionType.NOT_IS:
            result.push(idm_kb_service_client_js_1.MetaFieldType.DATE);
            result.push(idm_kb_service_client_js_1.MetaFieldType.DATE_TIME);
            result.push(idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE);
            result.push(idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME);
            break;
        case ConditionType.IS_SPECIFIED:
        case ConditionType.IS_NOT_SPECIFIED:
            result.push(idm_kb_service_client_js_1.MetaFieldType.INTEGER);
            result.push(idm_kb_service_client_js_1.MetaFieldType.DECIMAL);
            result.push(idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL);
            result.push(idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER);
            result.push(idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT);
            result.push(idm_kb_service_client_js_1.MetaFieldType.DATE);
            result.push(idm_kb_service_client_js_1.MetaFieldType.DATE_TIME);
            result.push(idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE);
            result.push(idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME);
            break;
    }
    return result;
}
exports.fieldTypesByCondition = fieldTypesByCondition;
function acceptableFields(allFields) {
    return allFields.filter(function (field) {
        return field.getType() === idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.DECIMAL ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.STRING ||
            // field.getType() === MetaFieldType.MULTILINGUAL_STRING ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE_TIME ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE ||
            field.getType() === idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE;
    });
}
exports.acceptableFields = acceptableFields;
function conditionsByFieldType(metaField) {
    var result = [];
    if (!lodash_1.isNil(metaField)) {
        switch (metaField.getType()) {
            case idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL:
            case idm_kb_service_client_js_1.MetaFieldType.INTEGER:
            case idm_kb_service_client_js_1.MetaFieldType.DECIMAL:
                result.push(ConditionType.EQUAL);
                result.push(ConditionType.NOT_EQUAL);
                result.push(ConditionType.BETWEEN);
                result.push(ConditionType.NOT_BETWEEN);
                result.push(ConditionType.GREATER_THAN);
                result.push(ConditionType.GREATER_THAN_OR_EQUAL);
                result.push(ConditionType.LESS_THAN);
                result.push(ConditionType.LESS_THAN_OR_EQUAL);
                result.push(ConditionType.IS_SPECIFIED);
                result.push(ConditionType.IS_NOT_SPECIFIED);
                break;
            case idm_kb_service_client_js_1.MetaFieldType.STRING:
                // case MetaFieldType.MULTILINGUAL_STRING:
                result.push(ConditionType.CONTAINS);
                result.push(ConditionType.NOT_CONTAINS);
                result.push(ConditionType.IS_SPECIFIED);
                result.push(ConditionType.IS_NOT_SPECIFIED);
                break;
            case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
            case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT:
                result.push(ConditionType.IN);
                result.push(ConditionType.NOT_IN);
                result.push(ConditionType.IS_SPECIFIED);
                result.push(ConditionType.IS_NOT_SPECIFIED);
                break;
            case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME:
            case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME:
            case idm_kb_service_client_js_1.MetaFieldType.DATE:
            case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE:
                result.push(ConditionType.IS);
                result.push(ConditionType.NOT_IS);
                result.push(ConditionType.IS_SPECIFIED);
                result.push(ConditionType.IS_NOT_SPECIFIED);
                break;
        }
    }
    return result;
}
exports.conditionsByFieldType = conditionsByFieldType;
var LogicUnitType;
(function (LogicUnitType) {
    LogicUnitType[LogicUnitType["CONDITION"] = 0] = "CONDITION";
    LogicUnitType["OR_OPERATOR"] = "Or";
    LogicUnitType["AND_OPERATOR"] = "And";
})(LogicUnitType = exports.LogicUnitType || (exports.LogicUnitType = {}));
var ConditionItem = /** @class */ (function () {
    function ConditionItem(id) {
        this.logicType = LogicUnitType.CONDITION;
        this.id = id;
    }
    ConditionItem.empty = function () {
        return new ConditionItem(utils_1.LayoutUtils.uniqueId());
    };
    ConditionItem.deserialize = function (key, value, fieldFinder, isWithNot) {
        var systemName = key.split('.')[1];
        var field = fieldFinder(systemName);
        var newCondition = new ConditionItem(utils_1.LayoutUtils.uniqueId());
        newCondition.field = field;
        if (lodash_1.isNumber(value)) {
            newCondition.conditionType = isWithNot
                ? ConditionType.NOT_EQUAL
                : ConditionType.EQUAL;
            newCondition.value = value;
        }
        else if (lodash_1.isDate(value)) {
            newCondition.conditionType = isWithNot
                ? ConditionType.NOT_IS
                : ConditionType.IS;
            newCondition.value = value;
        }
        else if (lodash_1.isString(value)) {
            newCondition.conditionType = ConditionItem.aptConditionTypeByField(field, isWithNot);
            if (lodash_1.startsWith(value, 'entity') || lodash_1.startsWith(value, 'item')) {
                var nestedSystemName = value.split('.')[1];
                newCondition.value = fieldFinder(nestedSystemName);
            }
            else {
                newCondition.value = value;
            }
        }
        else if (lodash_1.isObject(value)) {
            var typeKey = lodash_1.keys(value)[0];
            var nestedValue = lodash_1.values(value)[0];
            newCondition.conditionType = ConditionItem.aptConditionTypeByKey(typeKey, isWithNot);
            if (lodash_1.isString(nestedValue) && (lodash_1.startsWith(nestedValue, 'entity')
                || lodash_1.startsWith(nestedValue, 'item'))) {
                var nestedSystemName = nestedValue.split('.')[1];
                newCondition.value = fieldFinder(nestedSystemName);
            }
            else if (lodash_1.isString(nestedValue) ||
                lodash_1.isNumber(nestedValue) ||
                lodash_1.isArray(nestedValue)) {
                newCondition.value = nestedValue;
            }
        }
        return newCondition;
    };
    ConditionItem.aptConditionTypeByField = function (attachedField, isWithNot) {
        if (
        // attachedField.getType() === MetaFieldType.MULTILINGUAL_STRING ||
        attachedField.getType() === idm_kb_service_client_js_1.MetaFieldType.STRING) {
            return isWithNot
                ? ConditionType.NOT_CONTAINS
                : ConditionType.CONTAINS;
        }
        else if (attachedField.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE ||
            attachedField.getType() === idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE ||
            attachedField.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE_TIME ||
            attachedField.getType() === idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME) {
            return isWithNot ? ConditionType.NOT_IS : ConditionType.IS;
        }
        else {
            return isWithNot ? ConditionType.NOT_EQUAL : ConditionType.EQUAL;
        }
    };
    ConditionItem.aptConditionTypeByKey = function (typeKey, isWithNot) {
        switch (typeKey) {
            case '$in':
            case '$in-classifier':
            case '$in-multi-classifier':
                return isWithNot ? ConditionType.NOT_IN : ConditionType.IN;
            case '$between':
                return isWithNot
                    ? ConditionType.NOT_BETWEEN
                    : ConditionType.BETWEEN;
            case '$contains':
                return isWithNot
                    ? ConditionType.NOT_CONTAINS
                    : ConditionType.CONTAINS;
            case '$gte':
                return ConditionType.GREATER_THAN_OR_EQUAL;
            case '$gt':
                return ConditionType.GREATER_THAN;
            case '$lt':
                return ConditionType.LESS_THAN;
            case '$lte':
                return ConditionType.LESS_THAN_OR_EQUAL;
            case '$specified':
                return isWithNot ? ConditionType.IS_NOT_SPECIFIED : ConditionType.IS_SPECIFIED;
        }
    };
    ConditionItem.prototype.isSpecified = function () {
        return !lodash_1.isNil(this.conditionType) && !lodash_1.isNil(this.field) && ((lodash_1.isArray(this.value) && !lodash_1.isEmpty(this.value)) ||
            (!lodash_1.isArray(this.value) && !lodash_1.isNil(this.value))
            || this.conditionType === ConditionType.IS_SPECIFIED
            || this.conditionType === ConditionType.IS_NOT_SPECIFIED);
    };
    ConditionItem.prototype.isCondition = function () {
        return true;
    };
    ConditionItem.prototype.isOperator = function () {
        return false;
    };
    ConditionItem.prototype.toJs = function (isSubForm) {
        var _a;
        var resultObj = {};
        if (!lodash_1.isNil(this.field)) {
            var key = !isSubForm ? "entity." + this.field.getSystemName() :
                "item." + this.field.getSystemName();
            if (this.checkIfNegate()) {
                resultObj['$not'] = (_a = {},
                    _a[key] = this.valueToJs(isSubForm),
                    _a);
            }
            else {
                resultObj[key] = this.valueToJs(isSubForm);
            }
        }
        return resultObj;
    };
    ConditionItem.prototype.checkIfNegate = function () {
        return (this.conditionType === ConditionType.NOT_EQUAL ||
            this.conditionType === ConditionType.NOT_CONTAINS ||
            this.conditionType === ConditionType.NOT_IN ||
            this.conditionType === ConditionType.NOT_BETWEEN ||
            this.conditionType === ConditionType.IS_NOT_SPECIFIED ||
            this.conditionType === ConditionType.NOT_IS);
    };
    ConditionItem.prototype.valueToJs = function (isSubForm) {
        switch (this.conditionType) {
            case ConditionType.NOT_EQUAL:
            case ConditionType.EQUAL:
            case ConditionType.IS:
            case ConditionType.NOT_IS:
                if (this.value instanceof idm_kb_service_client_js_1.MetaField) {
                    return !isSubForm ? "entity." + this.value.getSystemName() :
                        "item." + this.value.getSystemName();
                }
                return this.value;
            case ConditionType.GREATER_THAN:
                if (this.value instanceof idm_kb_service_client_js_1.MetaField) {
                    return {
                        $gt: !isSubForm ? "entity." + this.value.getSystemName() :
                            "item." + this.value.getSystemName(),
                    };
                }
                return {
                    $gt: this.value,
                };
            case ConditionType.BETWEEN:
            case ConditionType.NOT_BETWEEN:
                return {
                    $between: this.value,
                };
            case ConditionType.GREATER_THAN_OR_EQUAL:
                if (this.value instanceof idm_kb_service_client_js_1.MetaField) {
                    return {
                        $gte: !isSubForm ? "entity." + this.value.getSystemName() :
                            "item." + this.value.getSystemName(),
                    };
                }
                return {
                    $gte: this.value,
                };
            case ConditionType.LESS_THAN:
                if (this.value instanceof idm_kb_service_client_js_1.MetaField) {
                    return {
                        $lt: !isSubForm ? "entity." + this.value.getSystemName() :
                            "item." + this.value.getSystemName(),
                    };
                }
                return {
                    $lt: this.value,
                };
            case ConditionType.LESS_THAN_OR_EQUAL:
                if (this.value instanceof idm_kb_service_client_js_1.MetaField) {
                    return {
                        $lte: !isSubForm ? "entity." + this.value.getSystemName() :
                            "item." + this.value.getSystemName(),
                    };
                }
                return {
                    $lte: this.value,
                };
            case ConditionType.CONTAINS:
            case ConditionType.NOT_CONTAINS:
                if (this.value instanceof idm_kb_service_client_js_1.MetaField) {
                    return {
                        $contains: !isSubForm ? "entity." + this.value.getSystemName() :
                            "item." + this.value.getSystemName(),
                    };
                }
                return {
                    $contains: this.value,
                };
            case ConditionType.IN:
            case ConditionType.NOT_IN:
                if (!lodash_1.isNil(this.field) && this.field.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER) {
                    return {
                        '$in-classifier': this.value
                    };
                }
                else if (!lodash_1.isNil(this.field) && this.field.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT) {
                    return {
                        '$in-multi-classifier': this.value
                    };
                }
                return {
                    $in: this.value
                };
            case ConditionType.IS_SPECIFIED:
            case ConditionType.IS_NOT_SPECIFIED:
                return {
                    $specified: ''
                };
        }
    };
    return ConditionItem;
}());
exports.ConditionItem = ConditionItem;
// tslint:disable-next-line:max-classes-per-file
var OrLogicOperator = /** @class */ (function () {
    function OrLogicOperator(id) {
        this.operands = [];
        this.logicType = LogicUnitType.OR_OPERATOR;
        this.isGroup = false;
        this.id = id;
    }
    OrLogicOperator.prototype.serialize = function () {
        return this.isGroup ? '$group-or' : '$or';
    };
    OrLogicOperator.prototype.isCondition = function () {
        return false;
    };
    OrLogicOperator.prototype.isOperator = function () {
        return true;
    };
    return OrLogicOperator;
}());
// tslint:disable-next-line:max-classes-per-file
var AndLogicOperator = /** @class */ (function () {
    function AndLogicOperator(id) {
        this.operands = [];
        this.logicType = LogicUnitType.AND_OPERATOR;
        this.isGroup = false;
        this.id = id;
    }
    AndLogicOperator.prototype.serialize = function () {
        return this.isGroup ? '$group-and' : '$and';
    };
    AndLogicOperator.prototype.isCondition = function () {
        return false;
    };
    AndLogicOperator.prototype.isOperator = function () {
        return true;
    };
    return AndLogicOperator;
}());
function operatorBuilder(key) {
    var operator;
    switch (key) {
        case '$and':
            operator = new AndLogicOperator(utils_1.LayoutUtils.uniqueId());
            break;
        case '$or':
            operator = new OrLogicOperator(utils_1.LayoutUtils.uniqueId());
            break;
        case '$group-or':
            operator = new OrLogicOperator(utils_1.LayoutUtils.uniqueId());
            operator.isGroup = true;
            break;
        case '$group-and':
            operator = new AndLogicOperator(utils_1.LayoutUtils.uniqueId());
            operator.isGroup = true;
            break;
    }
    return operator;
}
// tslint:disable-next-line:max-classes-per-file
var LogicConstruct = /** @class */ (function () {
    function LogicConstruct(isSubForm) {
        this.logic = ConditionItem.empty();
        this.isSubForm = isSubForm;
    }
    LogicConstruct.prototype.isEmpty = function () {
        return lodash_1.isNil(this.logic);
    };
    LogicConstruct.prototype.addItemOnEmpty = function () {
        this.logic = ConditionItem.empty();
    };
    LogicConstruct.prototype.addItemWithOr = function (itemIdAppendTo) {
        this.appendNewConditionItem(ConditionItem.empty(), itemIdAppendTo, operatorBuilder('$or'));
    };
    LogicConstruct.prototype.addItemWithAnd = function (itemIdAppendTo) {
        this.appendNewConditionItem(ConditionItem.empty(), itemIdAppendTo, operatorBuilder('$and'));
    };
    LogicConstruct.prototype.addNewGroupWithAnd = function () {
        var operator = operatorBuilder('$group-and');
        this.addNewGroupOperator(operator, ConditionItem.empty());
    };
    LogicConstruct.prototype.addToGroup = function () {
        if (this.logic.isOperator()) {
            var operator = this.logic;
            var newItem = ConditionItem.empty();
            newItem.parentOperator = operator;
            operator.operands.push(newItem);
        }
    };
    LogicConstruct.prototype.isGroupCreated = function () {
        if (this.logic.isOperator()) {
            return this.logic.isGroup;
        }
        return false;
    };
    LogicConstruct.prototype.addNewGroupWithOr = function () {
        var operator = operatorBuilder('$group-or');
        this.addNewGroupOperator(operator, ConditionItem.empty());
    };
    LogicConstruct.prototype.getFlatData = function () {
        var _this = this;
        var result = [];
        if (!lodash_1.isNil(this.logic)) {
            if (this.logic.isOperator()) {
                var operator = this.logic;
                if (operator.isGroup) {
                    result.push.apply(result, operator.operands.map(function (operand) {
                        return {
                            data: _this.flatting(operand, 0),
                            id: utils_1.LayoutUtils.uniqueId(),
                        };
                    }));
                }
                else {
                    result.push({
                        data: this.flatting(this.logic, 0),
                        id: utils_1.LayoutUtils.uniqueId(),
                    });
                }
            }
            else {
                result.push({
                    data: this.flatting(this.logic, 0),
                    id: utils_1.LayoutUtils.uniqueId(),
                });
            }
        }
        return result.filter(function (item) { return !lodash_1.isEmpty(item.data); });
    };
    LogicConstruct.prototype.toJs = function (isSubForm) {
        return !lodash_1.isNil(this.logic) ? this.toJsRec(isSubForm, this.logic) : {};
    };
    LogicConstruct.prototype.fromJs = function (logicObj, fieldFinder) {
        var result = this.fromJsRec(logicObj, fieldFinder);
        this.logic = !lodash_1.isNil(result) && !lodash_1.isEmpty(result) && !lodash_1.isEmpty(this.getFlatData())
            ? result : ConditionItem.empty();
    };
    LogicConstruct.prototype.test = function (logicObj, fieldFinder) {
        this.logic = this.fromJsRec(logicObj, fieldFinder);
    };
    LogicConstruct.prototype.deleteItem = function (itemId) {
        var item = this.findConditionItemById(itemId, this.logic);
        if (!lodash_1.isNil(item)) {
            if (item.id === this.logic.id) {
                this.logic = undefined;
            }
            else if (!lodash_1.isNil(item.parentOperator)) {
                this.deleteFromOperator(itemId, item.parentOperator);
                this.checkOneOperandOperators(this.logic);
            }
        }
        if (this.isEmpty()) {
            this.logic = ConditionItem.empty();
        }
    };
    LogicConstruct.prototype.deleteFromOperator = function (idToDelete, operator) {
        var currentOperator = operator;
        while (!lodash_1.isNil(currentOperator)) {
            this.deleteItemOnIndex(idToDelete, currentOperator.operands);
            if (lodash_1.isEmpty(currentOperator.operands)) {
                idToDelete = currentOperator.id;
                currentOperator = currentOperator.parentOperator;
                if (lodash_1.isNil(currentOperator)) {
                    this.logic = undefined;
                }
            }
            else {
                break;
            }
        }
    };
    LogicConstruct.prototype.checkOneOperandOperators = function (currentLogicUnit) {
        var _this = this;
        var currentOperator;
        if (!lodash_1.isNil(currentLogicUnit)) {
            console.log(currentLogicUnit);
            if (currentLogicUnit.logicType !== LogicUnitType.CONDITION) {
                currentOperator = currentLogicUnit;
                if (currentOperator.operands.length === 1) {
                    if (!lodash_1.isNil(currentOperator.parentOperator)) {
                        var index = currentOperator.parentOperator.operands.findIndex(function (prOperand) { return prOperand.id === currentOperator.id; });
                        currentOperator.parentOperator.operands[index] = currentOperator.operands[0];
                        currentOperator.parentOperator.operands[index].parentOperator = currentOperator.parentOperator;
                    }
                    else {
                        this.logic = currentOperator.operands[0];
                        this.logic.parentOperator = undefined;
                    }
                }
                else {
                    currentOperator.operands.forEach(function (operand) { return _this.checkOneOperandOperators(operand); });
                }
            }
        }
    };
    LogicConstruct.prototype.fromJsRec = function (currentObj, fieldFinder) {
        var _this = this;
        var valueToReturn;
        lodash_1.forOwn(currentObj, function (value, key) {
            if (key === '$or' ||
                key === '$and' ||
                key === '$group-or' ||
                key === '$group-and') {
                var operator_1 = operatorBuilder(key);
                if (Array.isArray(value)) {
                    value.forEach(function (obj) {
                        var unit = _this.fromJsRec(obj, fieldFinder);
                        if (!lodash_1.isNil(unit)) {
                            unit.parentOperator = operator_1;
                            operator_1.operands.push(unit);
                        }
                    });
                    valueToReturn = operator_1;
                }
            }
            else if (key === '$not') {
                lodash_1.forOwn(value, function (nestedValue, nestedKey) {
                    valueToReturn = ConditionItem.deserialize(nestedKey, nestedValue, fieldFinder, true);
                });
            }
            else if (lodash_1.startsWith(key, 'entity') || lodash_1.startsWith(key, 'item')) {
                valueToReturn = ConditionItem.deserialize(key, value, fieldFinder, false);
            }
        });
        return valueToReturn;
    };
    LogicConstruct.prototype.toJsRec = function (isSubForm, currentLogicLevel) {
        var _this = this;
        var _a;
        if (currentLogicLevel.isCondition()) {
            return currentLogicLevel.toJs(isSubForm);
        }
        else {
            var operator = currentLogicLevel;
            return _a = {},
                _a[operator.serialize()] = operator.operands.map(function (oper) {
                    return _this.toJsRec(isSubForm, oper);
                }),
                _a;
        }
    };
    LogicConstruct.prototype.flatting = function (currentLogicLevel, currentLevel) {
        var _this = this;
        var result = [];
        if (currentLogicLevel.isCondition()) {
            result.push({
                conditionItem: currentLogicLevel,
                level: currentLevel,
                operator: undefined,
            });
        }
        else {
            var operator = currentLogicLevel;
            result.push.apply(result, lodash_1.flattenDeep(operator.operands.map(function (operand) {
                return _this.flatting(operand, currentLevel + 1);
            })));
        }
        return result;
    };
    LogicConstruct.prototype.appendNewConditionItem = function (itemToAdd, itemIdAppendTo, newOperator) {
        var itemToAppendTo = this.findConditionItemById(itemIdAppendTo, this.logic);
        if (!lodash_1.isNil(itemToAppendTo)) {
            if (lodash_1.isNil(itemToAppendTo.parentOperator)) {
                itemToAppendTo.parentOperator = newOperator;
                itemToAdd.parentOperator = newOperator;
                newOperator.operands.push(itemToAppendTo);
                newOperator.operands.push(itemToAdd);
                this.logic = newOperator;
            }
            else {
                if (itemToAppendTo.parentOperator.logicType ===
                    newOperator.logicType) {
                    itemToAdd.parentOperator = itemToAppendTo.parentOperator;
                    if (itemToAdd.parentOperator.isGroup) {
                        this.insertNewOperator(newOperator, itemToAppendTo, itemToAdd);
                    }
                    else {
                        this.addItemOnIndex(itemToAdd, itemIdAppendTo, itemToAppendTo.parentOperator.operands);
                    }
                }
                else {
                    this.insertNewOperator(newOperator, itemToAppendTo, itemToAdd);
                }
            }
        }
    };
    LogicConstruct.prototype.findConditionItemById = function (itemId, currentLogicLevel) {
        var _this = this;
        if (currentLogicLevel.isCondition()) {
            if (currentLogicLevel.id === itemId) {
                return currentLogicLevel;
            }
        }
        else {
            var operator = currentLogicLevel;
            return operator.operands
                .map(function (operand) { return _this.findConditionItemById(itemId, operand); })
                .find(function (res) { return !lodash_1.isNil(res); });
        }
    };
    LogicConstruct.prototype.addItemOnIndex = function (itemToAdd, idToAppendTo, container) {
        container.splice(container.findIndex(function (item) { return item.id === idToAppendTo; }) + 1, 0, itemToAdd);
    };
    LogicConstruct.prototype.deleteItemOnIndex = function (idToDelete, container) {
        container.splice(container.findIndex(function (item) { return item.id === idToDelete; }), 1);
    };
    LogicConstruct.prototype.insertNewOperator = function (newOperator, toAppend, newItem) {
        var oldParent = toAppend.parentOperator;
        newOperator.operands.push(toAppend);
        newOperator.operands.push(newItem);
        newOperator.parentOperator = oldParent;
        this.addItemOnIndex(newOperator, toAppend.id, oldParent.operands);
        this.deleteItemOnIndex(toAppend.id, oldParent.operands);
        toAppend.parentOperator = newOperator;
        newItem.parentOperator = newOperator;
    };
    LogicConstruct.prototype.addNewGroupOperator = function (newOperator, newItem) {
        var oldLogic = this.logic;
        newOperator.operands.push(oldLogic);
        newOperator.operands.push(newItem);
        this.logic = newOperator;
        oldLogic.parentOperator = newOperator;
        newItem.parentOperator = newOperator;
    };
    return LogicConstruct;
}());
exports.LogicConstruct = LogicConstruct;
//# sourceMappingURL=meta-condition.js.map